module.exports = __webpack_public_path__ + "static/media/left-chevron.c5b73bfd.svg";